/**
 * Utility function to get the correct image URL
 * Handles both local paths (e.g., /uploads/image.jpg) and external URLs (e.g., https://...)
 *
 * @param imagePath - The image path or URL from the database
 * @returns The full image URL
 */
export const getImageUrl = (imagePath: string): string => {
  // Check if the image is already a full URL (starts with http:// or https://)
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Otherwise, it's a local path - prepend the API URL
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3002';
  return `${apiUrl}${imagePath}`;
};
